import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredContactsZeroState1Icon = (props: IconProps) => (
  <Icon height="32px" width="32px" viewBox="0 0 32 32" {...props}>
    <rect width="32" height="32" fill="#E5F2FF" rx="16" />
    <mask id="a" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse">
      <circle cx="16" cy="16" r="16" fill="#B94C24" />
    </mask>
    <path fill="#D9D9D9" d="M-5.12-6.08h63.36V54.4H-5.12z" />
    <path
      fill="#FFEACC"
      d="M13.197 10.069c-2.134.02-4.79 1.151-4.48 4.655.22 2.455.813 6.657 2.432 6.787.716.058 3.172-.834 3.172-.834l.205 2.933 4.606-1.21-1.808-3.803s2.907-8.595-4.127-8.526v-.002Z"
    />
    <path
      fill="#323232"
      d="m9.442 11.528 4.194 3.65c.272-1.146 1.151-1.094 1.791-.395.787.863-.172 2.029.028 2.336.202.306 1.595 1.508 1.866 1.476.272-.031 4.677-3.623.87-8.746-1.756-2.362-6.553-2.09-8.751 1.679h.002Z"
    />
    <path
      fill="#323232"
      d="M11.535 6.225c.049 1.685 1.13 2.706 2.664 2.663 1.532-.043 2.2-1.164 2.153-2.85-.048-1.684-.891-2.926-2.425-2.884-1.534.043-2.44 1.385-2.392 3.07v.001Z"
    />
    <path
      fill="#66AFFF"
      d="m13.23 22.077 14.703-3.603s2.987 9.314-4.414 9.748c-7.4.437-10.288-6.145-10.288-6.145h-.002Z"
    />
    <path
      fill="#66AFFF"
      d="M17.244 21.61c2.116.13 4.195.644 5.559 4.637 1.944 5.5 3.319 15.084 3.37 33.273L8.913 53.063c1.778-9.322 1.052-27.997 4.316-30.985 1.356-.57 2.218-.578 4.014-.466v-.002Z"
    />
  </Icon>
);

export default memo(StarredContactsZeroState1Icon);
